import myRequest from '@/services/myRequest';

export async function getYesterdaySum(params) {
  return myRequest('get', '/statistics/yesterdaySum', params);
}

export async function getLineChartSum(params) {
  return myRequest('get', '/statistics/lineChartSum', params);
}
